import { ITooltipListProps } from 'interfaces/components/tooltipList';
import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

const CustomTooltipList = ({
  tooltipList,
  tooltipListTitle,
  triggerElement
}: ITooltipListProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const [style, setStyle] = useState<React.CSSProperties>({});

  useEffect(() => {
    if (!triggerElement) return;

    const triggerRect = triggerElement.getBoundingClientRect();

    const spaceBelow = window.innerHeight - triggerRect.bottom;
    const spaceAbove = triggerRect.top;

    if (spaceBelow < 150 && spaceAbove > spaceBelow) {
      setStyle({
        bottom: `${window.innerHeight - triggerRect.top + 5}px`,
        left: `${triggerRect.left}px`,
        maxHeight: `${Math.min(300, spaceAbove - 10)}px`
      });
    } else {
      setStyle({
        top: `${triggerRect.bottom + 5}px`,
        left: `${triggerRect.left}px`,
        maxHeight: `${Math.min(300, spaceBelow - 10)}px`
      });
    }
  }, [triggerElement]);

  return ReactDOM.createPortal(
    <div
      ref={tooltipRef}
      className='fixed w-[200px] z-[9999] bg-black text-white shadow-lg rounded-md p-3 overflow-y-auto'
      style={style}
    >
      {tooltipListTitle && (
        <div className='text-sm sticky top-0 bg-black'>
          {tooltipListTitle}
        </div>
      )}
      {tooltipList && tooltipList.length > 0 && (
        <ul className='list-disc list-inside mt-2 pt-2 border-t border-gray-700'>
          {tooltipList.map((item, index) => (
            <li key={index} className='text-sm py-1 pr-2 rounded'>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>,
    document.body
  );
};

export default CustomTooltipList;
